/**
 * Loads the WMNDS SVG sprite into the page if not already present.
 * This allows SVG icons to be referenced anywhere in the app via <use>.
 * The sprite is loaded from the CDN and injected as a hidden div at the top of <body>.
 */
const icons = () => {
  // Only load the sprite if it hasn't already been loaded
  if (!document.querySelector('.wmnds-hidden-icons')) {
    // Create and send an AJAX request to fetch the SVG sprite
    const ajax = new XMLHttpRequest();
    ajax.open(
      'GET',
      'https://cloudcdn.wmca.org.uk/tfwmassets/ds/base/img/wmnds-icons.min.svg',
      true
    );
    ajax.send();
    ajax.onload = () => {
      // Create a hidden div to hold the SVG sprite
      const div = document.createElement('div');
      div.classList.add('wmnds-hidden-icons');
      div.style.display = 'none';
      div.innerHTML = ajax.responseText;
      // Insert the sprite at the top of the body
      document.body.insertBefore(div, document.body.childNodes[0]);
    };
  }
};

export default icons;
